type ErrorStates = {
  locationError: boolean;
  deliveryError: boolean;
};

export default function getHasErrored({
  locationError,
  deliveryError,
}: ErrorStates) {
  return Boolean(locationError || deliveryError);
}
